import React from 'react';

import styles from './signin.module.css'
import SignIn from '../components/SignIn/SignIn';

// state change poster/seeker->poster/seeker->verify

//will multiple states cause re render issues to non used components ?


export default function Signin() {
  console.log("SignIn mounted");

  return (
    <>
      <div className={styles.signup}>
        <div className={styles.featureImage}>
        </div>
        <div className={styles.container}>
          <SignIn />
        </div>

      </div>
    </>
  );
};
